<div class="personalization-popup-overlay" *ngIf="popupData && !isLoading">
  <div class="personalization-popup-content">
    <div class="modal-header">
      <h2>{{popupData.personalizationPopupTitle}}</h2>
      <button class="no-style close-btn" (click)="dismissAndSaveAll()">
        <mat-icon [svgIcon]="'close'" class="square-icon close-icon" aria-label="close"></mat-icon>
      </button>
    </div>

    <div class="personalization-popup-scroll-wrap">
      <div class="modal-subtitle-container">
        <h3 class="subtitle">{{popupData.personalizationPopupSubtitle}}</h3>
        <p class="description">{{popupData.personalizationPopupDescription}}</p>
      </div>

      <mat-dialog-content>
        <ng-container>
          <div class="dropdowns-container">

            <mat-form-field appearance="outline">
              <mat-label>{{popupData.facultiesFormListPlaceholder}}</mat-label>
              <mat-select [formControl]="facultiesForm"
                multiple class="personalization-popup-select"
                (selectionChange)="onFacultyOptionChange($event, 'facultiesForm')"
              >
                <mat-select-trigger class="display-flex">
                  <div *ngIf="(facultiesForm.value.length === popupData.facultiesOptions.length)" class="selected-options-text width-75">
                    {{ getOptionsTextByKey('facultiesForm')[0] }}
                  </div>
                  <div *ngIf="(facultiesForm.value.length !== popupData.facultiesOptions.length)" class="selected-options-text width-75">
                    {{ getOptionsTextByKey('facultiesForm') }}
                  </div>
                  <span *ngIf="(((facultiesForm.value.length || 0) > 1) && (facultiesForm.value.length !== popupData.facultiesOptions.length))" class="numbers-text">
                    ({{ popupData.chosenItemsPlaceholder.replace('{0}', facultiesForm.value.length.toString()) }})
                  </span>
                </mat-select-trigger>
                <mat-option *ngFor="let faculty of popupData.facultiesOptions" [value]="faculty.option.key" class="border-bottom">{{faculty.option.value}}</mat-option>
              </mat-select>
            </mat-form-field>

            <app-custom-search-dropdown
              [placeholder]="popupData.departmentsFormListPlaceholder"
              [control]="departmentsForm"
              [chosenItemsPlaceholder]="popupData.chosenItemsPlaceholder"
              [options]="departmentOptions"
              [chosenItemsPlaceholder]="popupData.chosenItemsPlaceholder"
              [searchPlaceholder]="popupData.departmentFilterSearchPlaceholder"
              [noResultsText]="popupData.departmentFilterNoResultsText"
              [clearButtonText]="popupData.departmentFilterClearButtonText"
              [submitButtonText]="popupData.departmentFilterSubmitButtonText"
              [disabled]="!departmentOptions.length"
            ></app-custom-search-dropdown>
            <div></div>
            <mat-form-field appearance="outline">
              <mat-label>{{popupData.campusesFormListPlaceholder}}</mat-label>
              <mat-select [formControl]="campusesForm"
                multiple class="personalization-popup-select"
                (selectionChange)="onOptionChange($event, 'campusesForm')"
              >
                <mat-select-trigger class="display-flex">
                  <div *ngIf="(campusesForm.value.length === popupData.campusesOptions.length)" class="selected-options-text width-75">
                    {{ getOptionsTextByKey('campusesForm')[0] }}
                  </div>
                  <div *ngIf="(campusesForm.value.length !== popupData.campusesOptions.length)" class="selected-options-text width-75">
                    {{ getOptionsTextByKey('campusesForm') }}
                  </div>
                  <span *ngIf="(((campusesForm.value.length || 0) > 1) && (campusesForm.value.length !== popupData.campusesOptions.length))" class="numbers-text">
                    ({{ popupData.chosenItemsPlaceholder.replace('{0}', campusesForm.value.length.toString()) }})
                  </span>
                </mat-select-trigger>
                <mat-option *ngFor="let campus of popupData.campusesOptions" [value]="campus.option.key" class="border-bottom">{{campus.option.value}}</mat-option>
              </mat-select>
            </mat-form-field>
            <mat-form-field appearance="outline">
              <mat-label>{{popupData.degreeLevelsFormListPlaceholder}}</mat-label>
              <mat-select [formControl]="degreeLevelsForm"
                multiple class="personalization-popup-select"
                (selectionChange)="onOptionChange($event, 'degreeLevelsForm')"
              >
                <mat-select-trigger class="display-flex">
                  <div *ngIf="(degreeLevelsForm.value.length === popupData.degreeLevelsOptions.length)" class="selected-options-text width-75">
                    {{ getOptionsTextByKey('degreeLevelsForm')[0] }}
                  </div>
                  <div *ngIf="(degreeLevelsForm.value.length !== popupData.degreeLevelsOptions.length)" class="selected-options-text width-75">
                    {{ getOptionsTextByKey('degreeLevelsForm') }}
                  </div>
                  <span *ngIf="(((degreeLevelsForm.value.length || 0) > 1) && (degreeLevelsForm.value.length !== popupData.degreeLevelsOptions.length))" class="numbers-text">
                    ({{ popupData.chosenItemsPlaceholder.replace('{0}', degreeLevelsForm.value.length.toString()) }})
                  </span>
                </mat-select-trigger>
                <mat-option *ngFor="let degreeLevel of popupData.degreeLevelsOptions" [value]="degreeLevel.option.key" class="border-bottom">{{degreeLevel.option.value}}</mat-option>
              </mat-select>
            </mat-form-field>

            <mat-form-field appearance="outline">
              <mat-label>{{popupData.academicYearsFormListPlaceholder}}</mat-label>
              <mat-select [formControl]="academicYearsForm"
                multiple class="personalization-popup-select"
                (selectionChange)="onOptionChange($event, 'academicYearsForm')"
              >
                <mat-select-trigger class="display-flex">
                  <div *ngIf="(academicYearsForm.value.length === popupData.academicYearsOptions.length)" class="selected-options-text width-75">
                    {{ getOptionsTextByKey('academicYearsForm')[0] }}
                  </div>
                  <div *ngIf="(academicYearsForm.value.length !== popupData.academicYearsOptions.length)" class="selected-options-text width-75">
                    {{ getOptionsTextByKey('academicYearsForm') }}
                  </div>
                  <span *ngIf="(((academicYearsForm.value.length || 0) > 1) && (academicYearsForm.value.length !== popupData.academicYearsOptions.length))" class="numbers-text">
                    ({{ popupData.chosenItemsPlaceholder.replace('{0}', academicYearsForm.value.length.toString()) }})
                  </span>
                </mat-select-trigger>
                <mat-option *ngFor="let academicYear of popupData.academicYearsOptions" [value]="academicYear.option.key" class="border-bottom">{{academicYear.option.value}}</mat-option>
              </mat-select>
            </mat-form-field>

          </div>

          <div class="dropdowns-container-mobile">
            <mat-expansion-panel class="catalog-expansion-panel" *ngFor="let formKey of ['facultiesForm','campusesForm','degreeLevelsForm','academicYearsForm']; let i = index" [style.order]="i">
              <mat-expansion-panel-header>
                <h2>{{ getPlaceholderByFormKey(formKey) }}</h2>
                <div class="display-flex options-selected-text">
                  <div *ngIf="isAllSelected(formKey)" class="numbers-text selected-options-text">
                    {{ getOptionsTextByKey(formKey)[0] }}
                  </div>
                  <div *ngIf="!isAllSelected(formKey)" class="numbers-text selected-options-text">
                    {{ getOptionsTextByKey(formKey) }}
                  </div>
                  <span *ngIf="getSelectedOptionsLength(formKey) > 1 && !isAllSelected(formKey)" class="numbers-text">
                    ({{ popupData.chosenItemsPlaceholder.replace('{0}', getSelectedOptionsLength(formKey).toString()) }})
                  </span>
                </div>
              </mat-expansion-panel-header>

              <mat-checkbox *ngFor="let option of getOptionsByForm(formKey)"
                            [checked]="getFormControlByKey(formKey).value.includes(option.option.key)"
                            (change)="onCheckboxChange(option.option.key, $event.checked, formKey)">
                {{ option.option.value }}
              </mat-checkbox>
            </mat-expansion-panel>
            <app-custom-search-dropdown
              class="department-filter"
              [placeholder]="popupData.departmentsFormListPlaceholder"
              [control]="departmentsForm"
              [chosenItemsPlaceholder]="popupData.chosenItemsPlaceholder"
              [options]="departmentOptions"
              [immediateSelect]="true"
              [wrapperClasses]="departmentsDropdownMobileClasses"
              [chosenItemsPlaceholder]="popupData.chosenItemsPlaceholder"
              [searchPlaceholder]="popupData.departmentFilterSearchPlaceholder"
              [noResultsText]="popupData.departmentFilterNoResultsText"
              [clearButtonText]="popupData.departmentFilterClearButtonText"
              [submitButtonText]="popupData.departmentFilterSubmitButtonText"
              [disabled]="!departmentOptions.length"
            ></app-custom-search-dropdown>
          </div>
        </ng-container>
      </mat-dialog-content>
    </div>
    <div class="popup-bottom-container">
      <div class="popup-bottom-container-text" (click)="clearAllOptions()">
        <a href="javascript:void(0)" role="button" tabindex="0">{{popupData.clearTextLink}}</a>
      </div>
      <div class="popup-bottom-container-buttons">
        <button mat-stroked-button (click)="dismissAndSaveAll()" color="primary" class="mobile-btn cancel-button">
          {{popupData.closeButtonText}}
        </button>
  
        <button mat-flat-button color="primary" (click)="savePersonalization()" class="btn-md submit-filter save-button" [ngClass]="{ disabled: !departmentsForm.value.length }" >
          {{popupData.saveButtonText}}
        </button>
      </div>
    </div>
  </div>
</div>

<div class="personalization-popup-overlay" *ngIf="isLoading">
  <div class="personalization-popup-content preloader">
    <app-preloader [miniPreloader]="true"></app-preloader>
  </div>
</div>